export enum ApiErrorCodesEnum {
  alreadyProcessedError = 'APIN021-010E',
}
